export const getLogger = f => f;
export default f => f;



// WEBPACK FOOTER //
// ./book/src/commons/components/ProdTools.jsx